import React, { useState } from 'react';
import { MapPin, CreditCard, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

const AppDownloadSection: React.FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isEng = t('common.loading') === 'Loading...';

  return (
    <section id="download" className="py-20 bg-[#1A1A1A] overflow-hidden relative">
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={isEng ? "Coming Soon" : "Em Breve"}
      >
        <div className="space-y-4">
          <p className="text-gray-600">
            {isEng 
              ? "The MotoRush app will be available soon for iOS and Android. Stay tuned!" 
              : "O aplicação MotoRush estará disponível em breve para iOS e Android. Fique atento às novidades!"}
          </p>
          <div className="pt-4 border-t border-gray-100">
            <a 
              href="https://wa.me/244954009112"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 p-3 bg-green-500 hover:bg-green-600 text-white rounded-xl transition-all duration-300 font-bold shadow-md hover:shadow-green-200"
            >
              <svg className="w-5 h-5 fill-current shrink-0" viewBox="0 0 24 24">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.724-1.455L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.37 9.864-9.799.002-2.63-1.023-5.101-2.885-6.966C16.59 1.988 14.113.96 11.49.959c-5.442 0-9.866 4.372-9.87 9.802 0 1.63.45 3.224 1.302 4.633L1.87 20.887l5.51-1.442.267.159zm11.23-6.805c-.328-.164-1.94-.959-2.24-1.07-.3-.109-.52-.164-.74.164-.22.329-.85 1.07-1.04 1.29-.19.22-.38.24-.7.08-.328-.164-1.386-.51-2.64-1.627-.975-.87-1.633-1.946-1.824-2.274-.19-.329-.02-.507.143-.67.147-.146.328-.382.49-.574.164-.19.22-.328.328-.548.11-.22.055-.41-.03-.574-.08-.164-.74-1.78-.99-2.41-.247-.592-.5-.509-.685-.519-.178-.009-.383-.01-.588-.01-.205 0-.537.077-.82.383-.283.307-1.082 1.057-1.082 2.578 0 1.52 1.107 2.99 1.26 3.2 1.764 2.455 3.415 3.659 5.86 4.605 2.445.945 2.445.63 2.885.589.44-.041 1.94-.794 2.213-1.52.274-.727.274-1.348.192-1.472-.083-.124-.302-.197-.63-.362z"/>
              </svg>
              <span>{isEng ? 'Chat on WhatsApp (954009112)' : 'Falar pelo WhatsApp (954009112)'}</span>
            </a>
          </div>
        </div>
      </Modal>

        {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-orange-500/10 to-transparent"></div>
      <div className="absolute bottom-0 right-0 w-1/2 h-full bg-gradient-to-l from-blue-500/10 to-transparent"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {isEng ? "The App Luanda Was Waiting For" : "A App que Luanda Estava à Espera"}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {isEng 
                ? "A complete experience, designed to simplify your everyday life in the city." 
                : "Uma experiência completa, desenhada para facilitar o seu dia-a-dia na cidade."}
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
            {/* Left Content */}
            <div className="lg:w-1/3 space-y-8 order-2 lg:order-1">
                <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-white/5 transition-colors">
                    <div className="p-3 bg-orange-500/20 rounded-lg text-orange-500">
                        <MapPin size={24} />
                    </div>
                    <div>
                        <h3 className="text-xl font-bold text-white mb-2">
                            {isEng ? "Real-Time Tracking" : "Rastreamento em Tempo Real"}
                        </h3>
                        <p className="text-gray-400">
                            {isEng ? "Follow your ride live on the map and share your journey." : "Acompanhe sua viagem no mapa ao vivo e compartilhe seu trajeto."}
                        </p>
                    </div>
                </div>
                <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-white/5 transition-colors">
                    <div className="p-3 bg-blue-500/20 rounded-lg text-blue-500">
                        <CreditCard size={24} />
                    </div>
                    <div>
                        <h3 className="text-xl font-bold text-white mb-2">
                            {isEng ? "Digital Payments" : "Pagamentos Digitais"}
                        </h3>
                        <p className="text-gray-400">
                            {isEng ? "Pay with Multicaixa Express, Card, or Cash safely." : "Pague com Multicaixa Express, Cartão ou Dinheiro de forma segura."}
                        </p>
                    </div>
                </div>
                <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-white/5 transition-colors">
                    <div className="p-3 bg-green-500/20 rounded-lg text-green-500">
                        <ShieldCheck size={24} />
                    </div>
                    <div>
                        <h3 className="text-xl font-bold text-white mb-2">
                            {isEng ? "Safe Transport" : "Transporte Seguro"}
                        </h3>
                        <p className="text-gray-400">
                            {isEng ? "Monitored rides and pre-selected drivers for your safety." : "Viagens monitoradas e motoqueiros selecionados para sua segurança."}
                        </p>
                    </div>
                </div>
            </div>

            {/* Center Phone Mockup */}
            <div className="lg:w-1/3 flex justify-center order-1 lg:order-2">
                 <div className="relative w-[280px] h-[580px] bg-black rounded-[45px] border-8 border-gray-800 shadow-2xl overflow-hidden ring-4 ring-gray-900/50">
                    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-6 bg-gray-800 rounded-b-xl z-20"></div>
                    {/* Screen Content */}
                    <div className="w-full h-full bg-gray-900 relative flex flex-col items-center justify-center">
                        <div className="absolute inset-0 bg-[url('https://api.mapbox.com/styles/v1/mapbox/dark-v10/static/13.234,-8.838,13,0/600x800@2x?access_token=pk.eyJ1IjoiZXhhbXBsZSIsImEiOiJjazl5b...')] bg-cover bg-center opacity-50"></div>
                         {/* Map overlay UI elements for effect */}
                         <div className="absolute inset-0 flex items-center justify-center">
                            <div className="relative">
                                <div className="absolute -inset-4 bg-orange-500/20 rounded-full animate-ping"></div>
                                <div className="w-4 h-4 bg-orange-500 rounded-full border-2 border-white relative z-10"></div>
                            </div>
                         </div>
                         <div className="absolute bottom-0 w-full p-4 bg-gradient-to-t from-black via-black/90 to-transparent pt-20">
                            <div className="bg-[#2A2A2A] p-4 rounded-xl border border-gray-700">
                                <div className="flex justify-between items-center mb-2">
                                    <div className="text-white font-bold">
                                        {isEng ? "Arriving in 3 min" : "A chegar em 3 min"}
                                    </div>
                                    <span className="text-xs bg-green-500/20 text-green-400 px-2 py-1 rounded">
                                        {isEng ? "On route" : "Em rota"}
                                    </span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-gray-600 rounded-full"></div>
                                    <div>
                                        <div className="text-sm text-white">João Paulo</div>
                                        <div className="text-xs text-gray-400">Lingken LK50-2B • LD-22-33</div>
                                    </div>
                                </div>
                            </div>
                         </div>
                    </div>
                </div>
            </div>

            {/* Right Content / CTA */}
            <div className="lg:w-1/3 text-center lg:text-left order-3">
                <h3 className="text-2xl font-bold text-white mb-6">
                    {isEng ? "Total Control in Your Hands" : "O Controlo Total nas Tuas Mãos"}
                </h3>
                <p className="text-gray-400 mb-8">
                    {isEng 
                        ? "Download now and discover why MotoRush is the fastest growing mobility app in Luanda." 
                        : "Baixe agora e descubra porque a MotoRush é a app de mobilidade que mais cresce em Luanda."}
                </p>
                <div className="flex flex-col gap-5 items-center lg:items-start">
                  <button 
                    onClick={() => setIsModalOpen(true)} 
                    className="transform hover:scale-105 transition-all duration-300 hover:opacity-90"
                  >
                    <img 
                      src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" 
                      alt={isEng ? "Download on App Store" : "Baixar na App Store"} 
                      className="h-14 border border-white/20 rounded-lg"
                    />
                  </button>
                  <button 
                    onClick={() => setIsModalOpen(true)} 
                    className="transform hover:scale-105 transition-all duration-300 hover:opacity-90"
                  >
                    <img 
                      src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                      alt={isEng ? "Get it on Google Play" : "Disponível no Google Play"}
                      className="h-14"
                    />
                  </button>
                </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownloadSection;
